

























































import { Component, Vue, Watch } from 'vue-property-decorator';

import { CookieOptions } from '@/interfaces/CookieOptions';
import { UserFormData } from '@/interfaces/UserFormData';
import { WebDemoType } from '@/types/WebDemoType';
import { Language } from '@/types/Language';

import axios from 'axios';

import TourialFrame from '@/components/TourialFrame.vue';
import Loader from './components/Loader.vue';
import FormComponent from './components/FormComponent.vue';
import GoToDesktopComponent from './components/GoToDesktopComponent.vue';

@Component({
  components: {
    TourialFrame,
    Loader,
    FormComponent,
    GoToDesktopComponent,
  },
})
export default class App extends Vue {
  isCookieExpired: boolean

  isMobile: boolean

  isUserReady: boolean

  isLeadReady: boolean

  isDemoReady: boolean

  isOverlayShown: boolean

  isTypForced: boolean

  isUserLogged: boolean

  isRequestingFormSubmit: boolean

  isActivation: boolean

  stepParam: string

  webDemoType = WebDemoType.NA

  language = Language.EN

  userFormData: UserFormData

  userEmail = ''

  iFrameUrl = ''

  tourialSlug = ''

  scenarioName = ''

  productCode = ''

  backgroundImg = ''

  webDemoId = 0

  frameWidth = ''

  styleObject: object

  constructor() {
    super();

    this.isCookieExpired = false;
    this.isMobile = false;
    this.isUserReady = false;
    this.isLeadReady = false;
    this.isDemoReady = false;
    this.isOverlayShown = false;
    this.isTypForced = false;
    this.isUserLogged = false;
    this.isRequestingFormSubmit = false;
    this.isActivation = false;
    this.styleObject = {};

    this.stepParam = '';

    this.userFormData = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_fname: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_lname: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_email: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_nsrv: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_phone: '',
    };
  }

  get isLoading() {
    return (!this.isLeadReady || !this.isDemoReady) && !this.isTypForced;
  }

  @Watch('isOverlayShown')
  onShowOverlay(isOverlayShown: boolean) {
    if (isOverlayShown) {
      document.body.classList.add('modal-open');
    } else if (!this.isMobile) {
      document.body.classList.remove('modal-open');
    }
  }

  @Watch('isLoading')
  onLoadingChange(val: boolean) {
    if (!val) {
      document.dispatchEvent(new CustomEvent('app:ready'));
    }
  }

  getCookie(name: string) {
    const pattern = `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`;
    const matches = document.cookie.match(new RegExp(pattern));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  setCookie(name: string, value: string, options: CookieOptions = {}): void {
    const { expires } = options;

    let expireDate: Date | null = null;
    let expireStr: string | null = null;

    if (expires) {
      const date = new Date();
      date.setTime(date.getTime() + expires * 1000);
      expireDate = date;
    }
    if (expireDate && expireDate.toUTCString) {
      expireStr = expireDate.toUTCString();
    }

    const cookieOptions = { ...options, expires: expireStr };

    let updatedCookie = `${name}=${encodeURIComponent(value)}`;

    Object.entries(cookieOptions).forEach(([cKey, cValue]) => {
      updatedCookie += `; ${cKey}`;
      if (cValue) {
        updatedCookie += `=${cValue}`;
      }
    });

    document.cookie = updatedCookie;
  }

  closeOverlay(): void {
    this.isOverlayShown = false;
  }

  setLeadReadyFlag(): void {
    this.isLeadReady = true;
  }

  setUserReadyFlag(): void {
    this.isUserReady = true;
  }

  loadParams() {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    // eslint-disable-next-line no-restricted-globals
    axios.post(`/webdemo/getparams${location.search}`, {
      // eslint-disable-next-line no-restricted-globals
      currentUrl: location.pathname,
    }, config).then((response) => {
      if (response.status === 200) {
        this.webDemoId = response.data.webDemoId;
        this.isMobile = response.data.isMobile;
        this.webDemoType = response.data.webDemoType;
        this.language = response.data.language;
        this.stepParam = response.data.stepParam;
        this.iFrameUrl = response.data.iFrameUrl;
        this.tourialSlug = response.data.tourialSlug;
        this.scenarioName = response.data.scenarioName;
        this.productCode = response.data.productCode;
        this.backgroundImg = response.data.backgroundImg;
        this.frameWidth = response.data.frameWidth;

        if (response.data.userFormData) {
          this.userFormData = response.data.userFormData;
        }
        this.userEmail = response.data.email;

        this.isDemoReady = true;
        this.setFrameStyles();
        this.requestFormSending();
      }
    });
  }

  requestFormSending() {
    const event = new CustomEvent('form:change', {
      detail: {
        webDemoId: this.webDemoId,
        product: this.productCode,
        name: this.scenarioName,
        topicAction: '',
        contentStage: '',
      },
    });
    document.dispatchEvent(event);
    if (this.stepParam === 'registered') {
      const isShowTyp = this.getCookie('web_demo_typ');
      if (isShowTyp) {
        this.isTypForced = true;
      } else {
        this.isCookieExpired = true;
      }

      this.isOverlayShown = true;
    } else if (!this.isActivation) {
      setTimeout(() => {
        this.isRequestingFormSubmit = true;
      }, 100);
    } else {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('form:lead-ready'));
        document.dispatchEvent(new CustomEvent('form:user-ready'));
        document.dispatchEvent(new CustomEvent('app:gaevent'));
      }, 100);
    }
  }

  setUserEmail(e: CustomEventInit) {
    this.userEmail = e.detail.email;
  }

  setFrameStyles() {
    this.styleObject = {
      background: `url(${this.backgroundImg}) top/contain no-repeat`,
      maxWidth: this.frameWidth ? `${this.frameWidth}px` : 'none',
    };
  }

  async mounted() {
    await this.loadParams();

    if (this.isMobile) {
      document.body.classList.add('modal-open');
    }

    document.addEventListener('email:set', (e: CustomEventInit) => {
      this.setUserEmail(e);
    });

    document.addEventListener('form:close', () => {
      this.closeOverlay();
    });
    document.addEventListener('form:lead-ready', () => {
      this.setLeadReadyFlag();
    });
    document.addEventListener('form:user-ready', () => {
      this.setUserReadyFlag();
    });
  }
}
